export const UPDATE_POST_PAGE_PROP = 'UPDATE_POST_PAGE_PROP';

// get post
export const GET_POST_STARTED = 'GET_POST_STARTED';
export const GOT_POST = 'GOT_POST';
export const GET_POST_FAILED = 'GET_POST_FAILED';



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/postPage/constants.js